<template lang="pug">
  v-snackbar(v-model="value.show" :timeout="value.timeout" top right vertical
      :color="color" auto-height)
    v-layout(align-end)
      v-spacer
      v-btn.ma-0.pa-0.btn(flat @click="value.show=false")
        v-icon.ma-0.pa-0.btn(small :color="color+' darken-4'") close
    p.pre.mt-0.mb-0(data-test="notification-message") {{ $tc(value.msg, value.count, value.params) }}
    v-layout(align-end)
      v-spacer
      v-btn.mt-1.pa-0.btn.text-none(flat v-if="value.action" :color="color+' darken-4'" :to="value.action.link" @click="value.show=false" style="text-decoration: underline")
        p.mr-2.mt-0.mb-0 {{ value.action.label }}
</template>

<style lang="stylus" scoped>
  .v-snack--vertical >>> .v-snack__content
    padding: 8px 8px 8px 16px !important;
  .btn:hover
    filter: drop-shadow(0px 0px 3px rgba(0,0,0,0.3))
  .pre
    white-space pre-wrap
</style>

<script>
export default {
  props: {
    value: Object,
  },
  computed: {
    color(){
      return this.value.error ? "error" : "info"
    },
  },
}
</script>
